import { LoadingOutlined } from "@ant-design/icons";
import { ArrowSelect } from "@components";

type TSuffixIcon = {
  loading: boolean;
  disableItemStore: boolean;
};

function SuffixIcon({ loading, disableItemStore }: TSuffixIcon) {
  return loading ? (
    <LoadingOutlined spin={loading} />
  ) : (
    <ArrowSelect disable={disableItemStore} />
  );
}

export default SuffixIcon;
